import React from 'react';

// Site-wide marketing footer. Rendered on the home page and every landing,
// programmatic, and hub page, so it doubles as the canonical internal-link
// surface that connects the pillar hubs (/compare, /use-cases, …) and every
// feature page back into the site graph. Keep the link lists in sync with the
// routes in src/App.js.
const TOOLS = [
  ['AI Tech Pack Generator', '/tech-pack-generator'],
  ['AI Photoshoots', '/ai-photoshoots'],
  ['AI Designer', '/ai-designer'],
  ['AI Color Changer', '/garment-recolor'],
  ['AI Fabric Swapper', '/fabric-swapper'],
  ['Lookbook Creator', '/product-view-generator'],
  ['Product Tagger', '/product-tagger'],
  ['Design Variations', '/design-variations'],
  ['AI Garment Editor', '/garment-editor'],
];

// Top-of-funnel free utilities (/free-tools pillar). Deliberately headed
// "Free Resources" — not "Tools" — so they read as giveaways for founders,
// not as siblings of the paid feature list above.
const FREE_RESOURCES = [
  ['Clothing Pricing Calculator', '/free-tools/clothing-pricing-calculator'],
  ['Startup Cost Calculator', '/free-tools/clothing-line-startup-cost-calculator'],
  ['Size Chart Generator', '/free-tools/size-chart-generator'],
  ['Care Label Generator', '/free-tools/care-label-generator'],
  ['Laundry Symbols Guide', '/free-tools/laundry-symbols'],
  ['Fashion Drop Planner', '/free-tools/fashion-drop-planner'],
  ['Spec Sheet Template', '/free-tools/spec-sheet-template'],
  ['BOM Template', '/free-tools/bill-of-materials-template'],
  ['Pantone TCX Finder', '/free-tools/pantone-tcx-finder'],
  ['Line Sheet Template', '/free-tools/line-sheet-template'],
  ['All free resources', '/free-tools'],
];

const EXPLORE = [
  ['Compare', '/compare'],
  ['Alternatives', '/alternatives'],
  ['Use cases', '/use-cases'],
  ['Glossary', '/glossary'],
  ['Fixes', '/fix'],
  ['Blog', '/blogs'],
  ['Insights', '/insights'],
];

const COMPANY = [
  ['Pricing', '/plans'],
  ['Get started free', '/sign-up'],
];

const LinkCol = ({ heading, links }) => (
  <div>
    <h3 className="text-xs font-semibold text-gray-900 uppercase tracking-wide mb-3">{heading}</h3>
    <ul className="space-y-2">
      {links.map(([label, href]) => (
        <li key={href}>
          <a href={href} className="text-sm text-gray-600 hover:text-gray-900 transition">{label}</a>
        </li>
      ))}
    </ul>
  </div>
);

const LandingFooter = ({ description = 'The AI operating system for fashion brands — design, sample, spec, and merchandise collections in minutes.' }) => (
  <footer className="bg-gray-50 border-t border-gray-100 mt-12">
    <div className="max-w-7xl mx-auto px-5 py-12">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
        {/* Brand */}
        <div className="col-span-2 md:col-span-1">
          <a href="/" className="inline-flex items-center text-gray-900 mb-3">
            <img src="/logo-black.png" alt="Adstronaut AI" className="h-7 w-7 mr-2" />
            <span className="font-bold">Adstronaut AI</span>
          </a>
          <p className="text-sm text-gray-500 max-w-xs">
            {description}
          </p>
        </div>

        <LinkCol heading="Tools" links={TOOLS} />
        <LinkCol heading="Free Resources" links={FREE_RESOURCES} />
        <LinkCol heading="Explore" links={EXPLORE} />
        <LinkCol heading="Company" links={COMPANY} />

        <div>
          <h3 className="text-xs font-semibold text-gray-900 uppercase tracking-wide mb-3">Legal</h3>
          <ul className="space-y-2">
            <li><a href="/legal/privacy-policy" className="text-sm text-gray-600 hover:text-gray-900 transition">Privacy Policy</a></li>
            <li><a href="/legal/terms-of-service" className="text-sm text-gray-600 hover:text-gray-900 transition">Terms of Service</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-gray-500">
        <p>&copy; {new Date().getFullYear()} AdcraftAI Pvt. Ltd. All rights reserved.</p>
        <p>Apartment No. 8C, Block 3, Asset Homes Signature, Kazhakuttam, Thiruvananthapuram-695582, Kerala</p>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
